export const BASE_API = 'https://us-central1-crested-talon-370815.cloudfunctions.net/app';

//http://localhost:5000